import React, { useState } from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, IconButton, TextField } from '@mui/material';

import TrashcanIcon from '../../../assets/icons/TrashcanIcon';
import { SEARCHBAR_BACKGROUND } from '../../../components/FreeTextSearchFilter';
import { SearchableSelectDropdownFilter } from '../../../components/SearchableSelectDropdownFilter/SearchableSelectDropdownFilter';

const WorkerTimecardDepartmentRow = ({
  corporationId,
  department,
  onAllocatedTimeChange,
  onDelete,
  onDepartmentChange,
  departmentAPICallback,
}) => {
  const [allocatedTime, setAllocatedTime] = useState(
    parseFloat(department?.allocatedTime ?? 0).toFixed(2)
  );

  return (
    <Box display="flex" gap="24px" alignItems="end">
      <SearchableSelectDropdownFilter
        disabled={!corporationId}
        placeholder="Department"
        onValueChange={onDepartmentChange}
        optionsAPICallback={departmentAPICallback(corporationId, department?.departmentId)}
        getOptionLabel={(option) => option.name}
        background={SEARCHBAR_BACKGROUND.DEFAULT}
        initialValue={department?.departmentId}
      />
      <TextField
        id="time-worked-input"
        label={LanguageConverterV2('timekeeping.workerTimecard.department.timeWorked')}
        variant="standard"
        defaultValue={allocatedTime}
        sx={{ width: '100px' }}
        onChange={(e) => {
          const v = e.target.value;
          let prevValue = 0;
          setAllocatedTime((prev) => {
            prevValue = prev;
            return v;
          });
          setTimeout(() => {
            onAllocatedTimeChange(parseFloat(prevValue) || 0, parseFloat(v) || 0);
          }, 500);
        }}
      />

      <IconButton onClick={onDelete} data-testid="removeDepartmentButton">
        <TrashcanIcon width={16} height={18} />
      </IconButton>
    </Box>
  );
};

WorkerTimecardDepartmentRow.propTypes = {
  corporationId: PropTypes.string,
  department: PropTypes.shape({
    departmentId: PropTypes.string,
    name: PropTypes.string,
    allocatedTime: PropTypes.number,
  }),
  onAllocatedTimeChange: PropTypes.func,
  onDelete: PropTypes.func,
  onDepartmentChange: PropTypes.func,
  departmentAPICallback: PropTypes.func,
};

export default WorkerTimecardDepartmentRow;
